import React from 'react'
import moment, { Moment } from 'moment'
import { LeaseDateStates } from '@api'

export const monthsUntil = (date: Moment) => {
  return date.diff(moment(), 'months', true)
}

export const getColor = (months: number) => {
  if (months < 0) return LeaseDateStates.EXPIRED
  if (months <= 3) return LeaseDateStates.DANGER
  if (months <= 12) return LeaseDateStates.WARNING
}

interface PrettyDateProps {
  colorize?: boolean
  value: number | string | Date | undefined
  momentFormat?: string
  utc?: boolean
  timeStringFormat?: string
  'data-input'?: string
}

export function prettyDate(props: PrettyDateProps) {
  const { value, momentFormat, utc, timeStringFormat } = props

  const format = momentFormat || 'MMM D, YYYY'

  return utc
    ? moment.utc(value, timeStringFormat).format(format)
    : moment(value, timeStringFormat).format(format)
}

/**
 * <PrettyDate value={'2019-05-20T00:00:00'} /> => <span>May 20, 2019<span>
 */
export default function PrettyDate(props: PrettyDateProps) {
  const color = props.colorize ? getColor(monthsUntil(moment(props.value))) : ''
  return props.value ? (
    <span data-input={props['data-input']} style={{ color }}>
      {prettyDate(props)}
    </span>
  ) : (
    <span data-input={props['data-input']}>-</span>
  )
}
